import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.importInfoPopover';

export default defineMessages({
  warnHeaderInfoEPUB: {
    id: `${scope}.warnHeaderInfo`,
    defaultMessage: 'We found these errors',
  },
  warnHeaderInfoDOCX: {
    id: `${scope}.warnHeaderInfo`,
    defaultMessage: 'We found these errors',
  },
  failHeaderInfoEPUB: {
    id: `${scope}.failHeaderInfoEPUB`,
    defaultMessage: 'We couldn\'t import your ePub',
  },
  failHeaderInfoDOCX: {
    id: `${scope}.failHeaderInfoDOCX`,
    defaultMessage: 'We couldn\'t import your Docx',
  },
  warnAdditionalInfo: {
    id: `${scope}.warnAdditionalInfo`,
    defaultMessage: 'Download the report for details.',
  },
  ingestionIdLabel: {
    id: `${scope}.ingestionIdLabel`,
    defaultMessage: 'Ingestion Id:',
  },
});
